/**
 * Robust OCR field extraction.
 *
 * The document OCR (passport / aadhar / voter / DL) usually returns
 * `fullName`, `address`, `pinCode`, but the vision LLM occasionally emits
 * variant keys (`name`, `full_name`, `pin_code`, `postal_code`, …) or a
 * structured address object. These helpers normalise every known variant so
 * name / address / pincode reliably populate the traveller form.
 */

// name = fullName || name || full_name || Name || customer_name
export function extractOcrName(ocr) {
  const name =
    ocr?.fullName ||
    ocr?.name ||
    ocr?.full_name ||
    ocr?.Name ||
    ocr?.customer_name ||
    '';
  return String(name).trim();
}

// address = address || Address || permanent_address || present_address.
// If it arrives as an object (line1/line2/city/state), flatten to one string.
export function extractOcrAddress(ocr) {
  let address =
    ocr?.address ||
    ocr?.Address ||
    ocr?.permanent_address ||
    ocr?.present_address ||
    '';
  if (address && typeof address === 'object') {
    address = [address.line1, address.line2, address.city, address.state]
      .filter(Boolean)
      .join(', ');
  }
  return String(address).trim();
}

// pincode = pinCode || pincode || pin_code || postal_code || zip.
// ALWAYS returned as a trimmed string — integer parsing drops leading zeros.
export function extractOcrPincode(ocr) {
  const pin =
    ocr?.pinCode ||
    ocr?.pincode ||
    ocr?.pin_code ||
    ocr?.postal_code ||
    ocr?.zip ||
    '';
  return String(pin).trim();
}
